import "./intro.scss"
import { init } from 'ityped'
import { useEffect, useRef } from "react"

export default function Intro() {

    const textRef = useRef();
    const textRef2 = useRef();

    useEffect(() => {
        init(textRef.current,{
            showCursor: true,
            backDelay: 1500,
            backSpeed: 60,
            strings: ["Engineer", "Developer"],

        });

        init(textRef2.current,{
            showCursor: true,
            backDelay: 1500,
            backSpeed: 60,
            strings: ["Science", "Analytics"],

        });
    
    }, [])

    return (
        <div className ="intro" id="intro">
            <div className="left">
                <div className="imgContainer">
                    <img src="asset/me2.png" alt="" />
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <h2>Hi There, I'm</h2>
                    <h1>Chloe Huang</h1>
                    <h3>Software <span ref={textRef}></span></h3>
                    <h3>Data <span ref={textRef2}></span></h3>
                </div>
                <a href="#portfolio">
                    <img src="asset/down.png" alt="" />
                </a>
            </div>
        </div>
    )
}
